export default __webpack_public_path__ + "static/step3-c680ff987f446c900e67ba110793dce0.webp";